<template>
  <v-expansion-panel 
    @click="handleExpand"
  >
    <v-expansion-panel-header>{{ $t('dtouch.workspace.menuExtFood.title', locale) }}</v-expansion-panel-header>
    <v-expansion-panel-content style="padding-top:16px;">
      <v-row>
        <v-col
          cols="12"
          sm="12"
        >
          <v-autocomplete
            v-model="menuExtWorkspace"
            :items="workspaces"
            :loading="loading"
            outlined
            dense
            item-text="name"
            item-value="id"
            :label="$t('dtouch.workspace.menuExtFood.id', locale)"
            hide-details
            @change="handleChangeData"
          />
        </v-col>
      </v-row>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>
<script>
import api from '@/services/api'
export default {
  name: 'MenuExtForm',
  props: {
    workspaceID: {
      type: String,
      default: null,
    },
    locale: {
      type: String,
      default: null,
    },
    onChangeData: {
      type: Function,
      default: null,
    },
  },
  data: () => ({
    menuExtWorkspace: null,
    workspaces: [],
    loading: true
  }),
  methods: {
    getWorkspaces () {
      api.getAllWithoutLimit('menuExt', 'v1/internal/workspaces')
        .then(response => {          
          this.workspaces = response.map(item => {
            return ({
              id: item.ID,
              name: item.Name
            })
          })
          this.loading = false
      })
    },
    getData () {
      api.getItem('dtouch', `v1/system/workspaces/`, `${this.workspaceID}/menu-ext`)
        .then(response => {
          this.menuExtWorkspace = response ? response.MenuExtWorkspace : null
        })
    },
    handleExpand () {
      this.getWorkspaces()
      if(!this.menuExtWorkspace && this.workspaceID) this.getData()
    },
    handleChangeData () {
      this.onChangeData({
        menuExtWorkspace: this.menuExtWorkspace
      })
    }
  },
}
</script>

